angular.module('property-deal')
    .controller('PropertyDealShowModalController', function ($scope, $rootScope, $uibModalInstance, data, PropertyDeal, LeadService, PropertyService, PropertyDealService, Principal) {
        this.LeadService = LeadService
        this.PropertyService = PropertyService
        this.PropertyDealService = PropertyDealService

        this.cancel = () => $uibModalInstance.dismiss('Canceled')

        this.$onInit = () => {
            PropertyDeal.get({id: data.id}).$promise.then(item => this.item = item, () => this.cancel())
            this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD'])
            this.canChangePrice = Principal.hasAnyAuthority(["ROLE_PROPERTY_DEAL_PRICE_CHANGE", "ROLE_PROPERTY_DEAL_PRICE_CHANGE_NO_LIMIT"])
            this.showDiscounts = false;
        }

        this.toggleShowDiscounts = () => {
            this.showDiscounts = !this.showDiscounts;
        }

        this.changePrice = (item) => {
            return PropertyDealService.changePrice(angular.copy(item)).then(result => {
                let form = {
                    id: data.id,
                    itemId: item.id,
                    calculationMethod: result.calculationMethod,
                    calculationBasedOn: result.calculationBasedOn,
                    vat: result.vat,
                    pricingBase: result.pricingBase,
                    pricing: result.pricing
                }
                PropertyDeal.priceUpdate(form).$promise.then(() => $rootScope.$broadcast('property-deal.updated'))
            })
        }
        this.changeLivingAreaFinal = item => {
            let form = {
                id: data.id,
                itemId: item.id,
                livingArea: item.property.livingArea,
                livingAreaFinal: item.property.livingAreaFinal
            }
            return PropertyDealService.changeLivingAreaFinal(form)
        }
        this.changeBankAccount = (item) => {
            let form = {
                id: data.id,
                itemId: item.id,
                bankAccount: item.bankAccount
            }
            return PropertyDealService.changeBankAccount(form)
        }
        $scope.$on('property-deal.updated', () => this.$onInit())
    })
